<template>
  <div class="order-container" ref="scrolltop" v-wechat-title="$route.meta.title= pageTitle">
    <barTitle :curUrlKey="curUrlKey" :titleText="titleText" :username="username" />
    <div class="tab-list">
      <div
        v-for="(item, index) in tabList"
        v-bind:key="item.id"
        class="item"
        :class="{ active: tabCur == index }"
        :style="{ color: tabCur == index ? colorFirst : '' }"
        @click.stop="handleToggleTab(item,index)"
      >
        {{ item.text }}
        <i
          class="line"
          :style="{ background: tabCur == index ? colorFirst : '' }"
        ></i>
      </div>
    </div>
    <div class="goods-list" v-if="goodsList.length">
      <div
        class="item"
        v-for="item in goodsList"
        :key="item.id"
        @click="gotoInfo(item)"
      >
        <img class="image" :src="item.activity_pic" />
        <div class="info">
          <div class="name">{{ item.activity_name }}</div>
          <div class="desc" v-if="item.state == 4">{{ item.failure_text }}</div>
          <div class="price">
            <span>{{ currencySymbol }}</span>
            <span class="integer">{{ item.bargain_money }}</span>
          </div>
          <button
            class="handle-btn"
            :style="{ background: colorFirst}"
            v-if="item.state == 1 || item.state == 2 || (item.state == 3 && item.is_buy == 0)"
          >
            {{ item.is_success == 1 ? '立即购买' : item.state_text }}
          </button>

          <div class="info-link" v-if="item.is_buy > 0 && item.state == 3" @click.stop="gotoOrderInfo(item)">订单详情 ></div>

          <img src="../../../static/images/bargain/failed.png" v-if="item.state == 4" class="seal failed" />
          <img src="../../../static/images/bargain/success.png" v-if="item.state == 3" class="seal success" />
        </div>
      </div>
    </div>
    <div class="not-list" v-else>
      <div class="not-list-content">
        <img
          class="not-list-img"
          src="http://aimg8.dlssyht.net.cn/xcx_pack/images/nolist.jpg"
          alt=""
        />
        <p class="not-list-text">抱歉暂无相关信息~</p>
      </div>
    </div>

    <div class="pagination" v-if="goodsList && total > 10">
      <button class="page-btn" @click="prevPage">上一页</button>
      <button class="page-btn" @click="nextPage">下一页</button>
    </div>
  </div>
</template>

<script>
import barTitle from "./components/Title";
export default {
  name: "bargainOrder",
  data() {
    return {
      curUrlKey: "order",
      pageTitle: "微砍价",
      titleText: "订单详情", // 标题文字
      isIndexList: false, // 是否为列表页
      goodsList: [], //商品列表
      page: 1, // 页码
      tabList: [
        // tab栏
        { text: "全部", id: 5 },
        { text: "待付款", id: 1 },
        { text: "活动中", id: 2 },
        { text: "已购买", id: 3 },
        { text: "已结束", id: 4 }
      ],
      tabCur: 0, // tab栏当前索引
      username: "", // 网站用户名
      act_id: "", //活动ID
      color: "", // 主题颜色
      domain: "",
      port: "",
      baseUrl: "",
      join_id: "",
      total: "",
      type: 5,
      setting: {},
      currencySymbol: '',
      colorFirst: '',
      lastFirst: ''
    };
  },
  components: {
    barTitle
  },
  created() {
    // 获取cookie
    let cookieArg = this.getCookieStringArgs();

    var params = this.$route.query;
    this.username = params.username;
    this.zz_userid = cookieArg['zz_userid'];
    this.zz_shellCode = cookieArg['zz_shellCode'];
    // this.currencySymbol = params.currencySymbol;
    // this.color = `#${params.color}`;
    if (document.location.protocol == "https:") {
      this.port = ":12702";
    } else {
      this.port = ":12701";
    }
    this.domain = document.domain;
    // this.domain = "m.evyun.cn";
    this.baseUrl = this.domain + this.port;
  },
  updated() {
    this._layer2my("closeAll", "loading");
  },
  mounted() {
    const orderParams = {
      username: this.username,
      zz_userid: this.zz_userid,
      zz_shellCode: this.zz_shellCode,
      type: this.type
    };
    this.getOrderInfo(orderParams);
    this.getSettingInfo();
    this._layer2my("closeAll", "loading");
  },
  methods: {
    // 跳转详情页
    gotoInfo(item) {
      const username = this.username;
      const zz_userid = this.zz_userid;
      const zz_shellCode = this.zz_shellCode;
      const join_id = item.join_id;
      const act_id = item.activity_id;
      const order = 1;
      this.$router.push({
        path: "/bargaining",
        query: {
          username,
          join_id,
          act_id,
          order
        }
      });
    },
    // 跳转订单详情
    gotoOrderInfo(item){
      location.href = `/dom/sc_order_detail.php?type=&id=${item.dingdan_id}&username=${this.username}&wap=1&bargain_join_id=${item.join_id}`
    },
    // 获取订单列表信息
    getOrderInfo(axparams) {
      this._layer2my("load");
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/bargainJoin`, {
          params: axparams
        })
        .then(this.getOrderInfoSuccess);
    },
    getOrderInfoSuccess(res) {
      res = res.data;
      let data = res.data;
      if (res.data && res.code == 200) {
        this._layer2my("closeAll", "loading");
        if (data.list == '' && this.page != 1) {
          this.page--;
          this._layer2my("msg", "没有更多数据了~");
        } else {
          this.goodsList = data.list;
          this.goodsPages = data.goodsPages;
          this.state = data.state;
          this.total = data.total;
          // this.$nextTick(function() {
            document.documentElement.scrollTop = 0;
          // });
        }
      }
    },
    // [设置]
    getSettingInfo() {
      let that = this;
      const axparams = {
        username: that.username
      };
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/bargainSet`, {
          params: axparams
        })
        .then(res => {
          res = res.data;
          if (res.data && res.code == 200) {
            this.setting = res.data.list;
            this.currencySymbol = res.data.currencySymbol;
            switch (that.setting.color) {
              case 0:
                that.colorFirst = "#F61E1E";
                that.colorLast = "#F91808";
                break;
              case 1:
                that.colorFirst = "#0084FF";
                that.colorLast = "#00B4FF";
                break;
              case 2:
                that.colorFirst = "#FF9900";
                that.colorLast = "#FFBE32";
                break;
              case 3:
                that.colorFirst = "#0BB854";
                that.colorLast = "#54CD87";
                break;
              case 4:
                that.colorFirst = res.data.list.color_first;
                that.colorLast = res.data.list.color_second;
                break;
              default:
                that.colorFirst = "#F61E1E";
                that.colorLast = "#F91808";
                break;
            }
          } else {
            that._layer2my("msg", res.msg);
          }
        });
    },
    // 下一页
    nextPage() {
      this.page++;
      const orderParams = {
        username: this.username,
        zz_userid: this.zz_userid,
        zz_shellCode: this.zz_shellCode,
        type: this.type,
        page: this.page
      };
      this.getOrderInfo(orderParams);
    },
    // 上一页
    prevPage() {
      if (this.page > 1) {
        this.page--;
        const orderParams = {
          username: this.username,
          zz_userid: this.zz_userid,
          zz_shellCode: this.zz_shellCode,
          type: this.type,
          page: this.page
        };
        this.getOrderInfo(orderParams);
      } else {
        this._layer2my("msg", "已经是第一页了哦~");
      }
    },
    // 切换订单
    handleToggleTab(item,index) {
      this.tabCur = index;
      this.type = item.id;
      const orderParams = {
        username: this.username,
        zz_userid: this.zz_userid,
        zz_shellCode: this.zz_shellCode,
        type: this.type
      };
      this.getOrderInfo(orderParams);
    },

    // 二次封装 layui
    _layer2my(type, str) {
      layui.use("layer", function() {
        layer.ready(function() {
          switch (type) {
            case "msg":
              layer.msg(str, { time: 1500 });
              break;
            case "load":
              layer.load({
                shade: true
              });
              break;
            case "closeAll":
              layer.closeAll(str);
              break;
            default:
              layer.msg(str, { time: 1500 });
          }
        });
      });
    },
    // 查询cookie参数
    getCookieStringArgs() {
      const cs = document.cookie.length > 0 ? document.cookie.replace(/\s/g, "") : "";
      // const cs = this.getCookie().replace(/\s/g, ""); // 获取本地模拟cookies
      let args = {},
        items = cs.length > 0 ? cs.split(";") : [],
        item = null,
        name = null,
        value = null,
        i = 0,
        len = items.length;
      for (i; i < len; i++) {
        item = items[i].split("=");
        name = decodeURIComponent(item[0]);
        value = decodeURIComponent(item[1]);
        if (name.length) {
          args[name] = value;
        }
      }
      return args;
    },
    // 本地模拟获取cookie登录状态
    getCookie() {
      // 未登录
      // const cookies = "";
      // 别人
      // const cookies = "zz_userid=21062530;zz_shellCode=31d1791fe6c4d41cd202767760c9d581";
      // 自己
      const cookies = "zz_userid=21263772;zz_shellCode=c76676e680a08b9f0af490035b39396e;";
      return cookies;
    },
  }
};
</script>

<style scoped lang="scss">
.order-container {
  min-width: 3.2rem;
  max-width: 7.68rem;
  margin: 0 auto;
  min-height: 100vh;
  background: #f8f8f8;
}
.tab-list {
  position: fixed;
  top: 1rem;
  right: 0;
  left: 0;
  height: 0.66rem;
  display: flex;
  justify-content: space-around;
  padding: 0 0.3rem 0;
  background: #fff;
  z-index: 99;
}
.tab-list .item {
  position: relative;
  text-align: center;
  height: 0.66rem;
  line-height: 0.66rem;
  font-size: 0.26rem;
}
.tab-list .item.active {
  color: #f61e1e;
}
.tab-list .item.active .line {
  display: block;
  width: 0.5rem;
  height: 0.05rem;
  background: #f61e1e;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}

.goods-list {
  padding: 1.76rem 0.25rem 0;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.2rem;
  background: #fff;
}
.goods-list .item {
  display: flex;
  flex-direction: row;
  padding: 0.3rem 0;
  border-top: 1px solid #ededed;
}
.goods-list .item:first-child {
  border-top: none;
}
.goods-list .image {
  margin-right: 0.42rem;
  flex: 0 0 2.2rem;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: .12rem;
}
.goods-list .info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}
.goods-list .info .desc {
  color: #999;
}
.goods-list .name {
  font-size: 0.3rem;
  overflow : hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  color: #333;
}
.goods-list .price {
  font-size: 0;
  color: #e51722;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  > span {
    font-size: 0.24rem;
  }
}
.goods-list .integer {
  font-size: 0.38rem !important;
}

.goods-list .handle-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 0.28rem;
  color: #ffffff;
  width: 1.6rem;
  height: 0.6rem;
  background: rgba(255, 46, 31, 1);
  border-radius: 0.05rem;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.goods-list .handle-btn.end {
  background: #eeeeee;
  color: #888888;
}
.not-list {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
}
.not-list-content {
  position: absolute;
  top: 20vh;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 0.28rem;
  color: #999;
  .not-list-img {
    display: block;
    width: 3rem;
    height: 3rem;
    margin: 0 auto;
  }
  .not-list-p {
    margin-top: 0.2rem;
  }
}
.pagination {
  padding: 0 1.6rem;
  display: flex;
  justify-content: space-around;
}
.pagination .page-btn {
  width: 1.5rem;
  height: 0.8rem;
  border-radius: 0.12rem;
  background: #fff;
  border: 0.01rem solid #eee;
  font-size: 0.28rem;
  text-align: center;
  line-height: 0.8rem;
  margin-bottom: 0.2rem;
}
.order-container >>> .title-container {
  position: fixed;
}
.seal {
  position: absolute;
  right: 0;
  top: 0;
  display: block;
  width: 1.4rem;
  height: 1.4rem;
}
.info-link {
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: .26rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/Bargain/Order.vue